<div class="card-container">
  <!-- IMAGEM E ICONES -->
  <div class="image-container">
    <img *ngIf="itemCard.photos" [src]="itemCard.photos[0].url" alt="Card" onerror="this.src='/assets/imgs/image-gallery-default.png'">
    <img *ngIf="!itemCard.photos" src="/assets/imgs/image-default.png" alt="Card">
    <div class="icons-container">
      <div *ngFor="let product_value of itemCard.product_values" >
        <div class="icon-default" *ngIf="productsValuesShowing.includes(product_value.type)">
          <img src="../../../../assets/svgs/{{product_value.type}}.svg" alt="Medida">
          <p>{{ product_value.value }} <span *ngIf="product_value.type === 'total_area'">m²</span></p>
        </div>
      </div>
    </div>
    <div class="linear"></div>
  </div>
  <!-- ICONE DE PORCENTAGEM JUNTO COM TIPO DO EMPREENDIMENTO + AÇÔES -->
  <div class="action-porcent">
    <div class="market-type" *ngIf="itemCard.market_type">
      <p class="market-type-text">{{itemCard.market_type}}</p>
    </div>
    <!-- 
    <div class="porcent-action">
      <div class="chart-content" *ngIf="itemCard.porcentagem < 100">
        <canvas id="greenChart" baseChart [data]="[itemCard.porcentagem, 100 - itemCard.porcentagem]" [labels]="''"
          [colors]="doughnutChartColorA" [options]="doughnutChartOptions" [chartType]="'doughnut'">
        </canvas>
        <span>{{ itemCard.porcentagem < 10 ? '0' : '' }}{{ itemCard.porcentagem || '0' }}</span>
      </div>
      <img src="../../../../assets/svgs/congratulations.svg" class="prb" alt="Parabéns" *ngIf="itemCard.porcentagem >= 100">
      <button class="btn-card">
        <img src="../../../../assets/svgs/i_dot_options.svg" alt="Tipo">
      </button>
    </div> -->
  </div>
  <!-- DESCRIÇÂO DO IMOVEL COM SEU TIPO -->
  <div class="description">
    <p class="type"><span *ngIf="itemCard.property_type">{{ itemCard.property_type }}{{ itemCard.property_sub_type && (itemCard.property_type.toLowerCase() !== itemCard.property_sub_type.toLowerCase()) ? "/"+itemCard.property_sub_type : "" }}</span></p>
    <p class="code-enterprise">{{ itemCard.sku }} <span *ngIf="itemCard.name">{{ " - " + itemCard.name }}</span></p>
  </div>
  <!-- VENDA OU LOCAÇÂO -->
  <div class="sales-rent-container">
    <div class="sales-rent">
      <p class="sr">Venda / Locação</p>
      <p class="value-sr"><span *ngIf="itemCard.sale_value">{{itemCard.sale_value.currency + itemCard.sale_value.value }}</span><span *ngIf="itemCard.rent_value"> / {{itemCard.rent_value.currency + itemCard.rent_value.value }}</span></p>
    </div>
    <div class="sales-rent" *ngIf="itemCard.condominium_fee">
      <p class="sr">Condo. + IPTU</p>
      <p class="value-sr">{{itemCard.condominium_fee.currency + itemCard.condominium_fee.value }}</p>
    </div>
  </div>
  <!-- ENDEREÇO -->
  <div class="unity-address">
    <p class="address">
      {{ itemCard.address.street + ', '}}
      {{'n°' + itemCard.address.number + '-'}}
      {{ itemCard.address.neighborhood + ', '}}
      {{ itemCard.address.city + ' - ' }}
      {{ itemCard.address.state }}</p>
    <p class="unity-tower"><span *ngIf="itemCard.tower">{{ itemCard.tower + ', '}} </span> <span *ngIf="itemCard.unity_number">{{'unid ' + itemCard.unity_number}}</span></p>
  </div>
  <!-- ESTAGIO -->
  <div class="status-card" *ngIf="false">
    <p class="updating-card">Atualização: 10/10/2010</p>
  </div>
  <!-- LISTA DE ICONES -->
  <ul class="list-icons" *ngIf="false">
    <li class="icons" matTooltip="2">
      <img src="../../../../assets/svgs/predio.svg" alt="">
      <p>2</p>
    </li>
    <li class="icons" matTooltip="Estrela">
      <img src="../../../../assets/svgs/star.svg" alt="">
    </li>
    <li class="icons" matTooltip="Usuário">
      <img src="../../../../assets/svgs/user.svg" alt="">
    </li>
    <li class="icons" matTooltip="Especial">
      <img src="../../../../assets/svgs/diamond.svg" alt="">
    </li>
    <li class="icons" matTooltip="Pacotes">
      <img src="../../../../assets/svgs/icon_package.svg" alt="">
    </li>
    <li class="icons" matTooltip="Calendário">
      <img src="../../../../assets/svgs/calender.svg" alt="">
    </li>
    <li class="icons" matTooltip="Dinheiro">
      <img src="../../../../assets/svgs/icon_new_money.svg" alt="">
    </li>
  </ul>
</div>